import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import DataGridComp from '../../../../Core/Grid';
import formatters from '../../../../Core/Grid/inputFormatter';

import { AppStorage } from '../../../../Core/Service/storage-service';
import moment from 'moment';
import { Tcard } from '../Dashboard/TcardTemplates/mainTcard';

const BookingDetailsList = (props) => {
    const portalSetting = AppStorage.getPortalSetting();
    const statusObject = JSON.parse(AppStorage.getTCardStatus());

    const [state, setState] = useState({
        rows: props.selectedBookingList.map((q) => ({ ...q, id: q.tCardsID })) || []
    });

    const legendItems = [
        {
            label: portalSetting.portalSettingsCollectionDeliverText,
            background: portalSetting.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSetting.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSetting.portalSettingsCustomerWaitingText,
            background: portalSetting.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSetting.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSetting.portalSettingsServiceText,
            background: portalSetting.portalSettingsServiceBgColor || 'black',
            color: portalSetting.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSetting.portalSettingsInspectionText,
            background: portalSetting.portalSettingsInspectionBgColor || 'black',
            color: portalSetting.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSetting.portalSettingsMOTText,
            background: portalSetting.portalSettingsMOTBgColor || 'black',
            color: portalSetting.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSetting.portalSettingsRepairText,
            background: portalSetting.portalSettingsRepairBgColor || 'black',
            color: portalSetting.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSetting.portalSettingsNightShiftText,
            background: portalSetting.portalSettingsNightShiftBgColor || 'black',
            color: portalSetting.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSetting.portalSettingsRecallJobText,
            background: portalSetting.portalSettingsRecallJobBgColor || 'black',
            color: portalSetting.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },

        {
            label: portalSetting.portalSettingsTachoText,
            background: portalSetting.portalSettingsTachoBgColor || 'black',
            color: portalSetting.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    return (
        <Grid container style={{ height: '500px', overflowY: 'auto' }}>
            <Grid item xs={12}>
                {state.rows.map((k) => {
                    let tempStatusObj = statusObject.find((s) => s.id == k.sid);
                    return (
                        <Tcard
                            hideBookingDate={true}
                            legendItems={legendItems}
                            handleTcardOpen={props.handleTcardOpen}
                            date={k.bd}
                            customer={k.tCardsCustomerName}
                            isLoanVehicle={k.loanVehicle}
                            registration={k.registration}
                            bg={tempStatusObj?.bgc}
                            color={tempStatusObj?.bgc}
                            tCardsID={k.tCardsID}
                            breakdown={k.breakdown}
                            breakdownStatus={k.breakdownStatus}
                            breakdownTime={k.breakdownTime}
                            status={{
                                recall: k.tCardsIsRecallJob,
                                tacho: k.tCardsIsTacho,
                                motdate: k.tCardsMOTDate,
                                motloc: k.tCardsMotloc,
                                mot: k.tCardsIsMOT,
                                repair: k.tCardsIsRepair,
                                inspection: k.tCardsIsInspection,
                                cd: k.tCardsIsCollectionDeliver,
                                waiting: k.tCardsIsCustomerWaiting,
                                service: k.tCardsIsService,
                                ns: k.tCardsIsNightShift
                            }}
                        />
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default BookingDetailsList;
